// extracted by mini-css-extract-plugin
export default {"optionsBody":"style_optionsBody__i3bs4"};